import { render } from "./BreedingGeneralTable.vue?vue&type=template&id=07af211e&scoped=true&ts=true"
import script from "./BreedingGeneralTable.vue?vue&type=script&lang=ts"
export * from "./BreedingGeneralTable.vue?vue&type=script&lang=ts"

import "./BreedingGeneralTable.vue?vue&type=style&index=0&id=07af211e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07af211e"]])

export default __exports__